// FIXME: This is currently unused.
export var DaysOfWeek;
(function (DaysOfWeek) {
    DaysOfWeek[DaysOfWeek["Sunday"] = 0] = "Sunday";
    DaysOfWeek[DaysOfWeek["Monday"] = 1] = "Monday";
    DaysOfWeek[DaysOfWeek["Tuesday"] = 2] = "Tuesday";
    DaysOfWeek[DaysOfWeek["Wednesday"] = 3] = "Wednesday";
    DaysOfWeek[DaysOfWeek["Thursday"] = 4] = "Thursday";
    DaysOfWeek[DaysOfWeek["Friday"] = 5] = "Friday";
    DaysOfWeek[DaysOfWeek["Saturday"] = 6] = "Saturday";
})(DaysOfWeek || (DaysOfWeek = {}));
export var OrderSummaryText;
(function (OrderSummaryText) {
    OrderSummaryText["ORDER_SUMMARY"] = "Order Summary";
})(OrderSummaryText || (OrderSummaryText = {}));
export var CartSelectionModeType;
(function (CartSelectionModeType) {
    CartSelectionModeType[CartSelectionModeType["NONE"] = 0] = "NONE";
    CartSelectionModeType[CartSelectionModeType["CAN_ADD_REMOVE_MEALS"] = 10] = "CAN_ADD_REMOVE_MEALS";
    CartSelectionModeType[CartSelectionModeType["CAN_ADD_REMOVE_RECIPES"] = 20] = "CAN_ADD_REMOVE_RECIPES";
})(CartSelectionModeType || (CartSelectionModeType = {}));
export var RecipeDisplayNameType;
(function (RecipeDisplayNameType) {
    RecipeDisplayNameType[RecipeDisplayNameType["SHORT_NAME"] = 0] = "SHORT_NAME";
    RecipeDisplayNameType[RecipeDisplayNameType["LONG_NAME"] = 10] = "LONG_NAME";
})(RecipeDisplayNameType || (RecipeDisplayNameType = {}));
export var DefaultDaySectionExpansionType;
(function (DefaultDaySectionExpansionType) {
    DefaultDaySectionExpansionType[DefaultDaySectionExpansionType["EXPANDED"] = 0] = "EXPANDED";
    DefaultDaySectionExpansionType[DefaultDaySectionExpansionType["COLLAPSED"] = 10] = "COLLAPSED";
})(DefaultDaySectionExpansionType || (DefaultDaySectionExpansionType = {}));
export var DefaultCartText;
(function (DefaultCartText) {
    DefaultCartText["PLAN_NAME"] = "Plan name";
    DefaultCartText["START_DATE"] = "START_DATE";
    DefaultCartText["SUBSCRIPTION_PERIOD"] = "Subscription Period";
    DefaultCartText["OMISSIONS"] = "Omissions";
    DefaultCartText["DELIVERY_METHOD"] = "Delivery Method";
    DefaultCartText["RECIPE_TYPE"] = "Recipe Type";
    DefaultCartText["MEAL_SIZE"] = "Meal size";
    DefaultCartText["SUBSCRIPTION_DISCOUNT"] = "Subscription Discount";
    DefaultCartText["PICKUP_LOCATION"] = "Pickup location";
    DefaultCartText["POSTAL_CODE"] = "Postal code";
    DefaultCartText["PRODUCT_LABEL"] = "Addons";
    DefaultCartText["SUBSCRIPTION_SECTION_LABEL"] = "Subscriptions";
    DefaultCartText["PRICING"] = "Pricing";
    DefaultCartText["SUBTOTAL"] = "Subtotal";
    DefaultCartText["TAX"] = "Tax";
    DefaultCartText["TOTAL"] = "Total";
    DefaultCartText["DELIVERY"] = "Delivery";
    DefaultCartText["DISCOUNT"] = "Discount";
    DefaultCartText["COUPON"] = "Coupon";
    DefaultCartText["SUB_DISCOUNT"] = "Sub. Discount";
    DefaultCartText["SHORT_WEEK_INDICATOR_MEALS"] = "Your first order is a short week due to your start date.";
    DefaultCartText["SHORT_WEEK_INDICATOR_PRODUCTS"] = "The following products are not available due to your start date.";
    DefaultCartText["SURCHARGE"] = "Surcharge";
    DefaultCartText["NEXT_ORDER_SUBTOTAL"] = "Next Order's Subtotal";
    DefaultCartText["BALANCE_DUE"] = "Balance Due";
    DefaultCartText["AMOUNT_PAID"] = "Amount Paid";
    DefaultCartText["ACCOUNT_CREDIT"] = "Account Credit";
    DefaultCartText["GIFT_CARD"] = "GiftCard";
})(DefaultCartText || (DefaultCartText = {}));
